import { CLIENT_SET_PASSWORD, CLIENT_SET_PASSWORD_ERROR, CLIENT_SET_PASSWORD_HIDE_ERROR, CLIENT_SET_PASSWORD_START_LOADER, CLIENT_SET_PASSWORD_STOP_LOADER, } from "../interface/IClientSetPassword";
const initState = {
    data: {
        message: "",
        passwordReset: false,
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const ClientSetPassword = (state = initState, action) => {
    switch (action.type) {
        case CLIENT_SET_PASSWORD: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case CLIENT_SET_PASSWORD_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case CLIENT_SET_PASSWORD_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case CLIENT_SET_PASSWORD_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case CLIENT_SET_PASSWORD_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default ClientSetPassword;
